module.exports = __webpack_public_path__ + "static/img/b12.4f1346b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b12.png
// module id = RqFw
// module chunks = 0